import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";
import { callErrorToast } from "../../../utilities/index.js";
import { OrdersService } from "../../../services/logistic/orders.ts";

const ordersService = new OrdersService();

interface RejectOrderProviderProps {
  children: ReactNode;
  data?: string[];
  callback?: () => void;
}

interface RejectOrderContextValue {
  loader: boolean;
  rejectOrders: (motivation: string) => void;
  data: string[];
  callback?: () => void;
}

const RejectOrderContext = createContext<RejectOrderContextValue | undefined>(
  undefined
);

const RejectOrderProvider: React.FC<RejectOrderProviderProps> = ({
  children,
  data = [],
  callback,
}) => {
  const [error, setError] = useState<unknown>(null);
  const [loader, setLoader] = useState<boolean>(false);

  const rejectOrders = (motivation: string): void => {
    setLoader(true);
    const promises = data.map((id) => ordersService.reject(id, motivation));
    Promise.all(promises)
      .then((res) => {
        setLoader(false);
        if (callback) {
          callback();
        }
      })
      .catch((err) => {
        setLoader(false);
        setError(err);
      });
  };

  useEffect(() => {
    if (error) {
      callErrorToast(error);
    }
  }, [error]);

  return (
    <RejectOrderContext.Provider
      value={{ loader, rejectOrders, data, callback }}
    >
      {children}
    </RejectOrderContext.Provider>
  );
};

const useRejectOrderContext = (): RejectOrderContextValue => {
  const context = useContext(RejectOrderContext);
  if (!context) {
    throw new Error(
      "useRejectOrderContext must be used within a RejectOrderProvider"
    );
  }
  return context;
};

export { RejectOrderProvider, useRejectOrderContext };
